import {
  Grid,
  Typography,
} from "@mui/material";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCurrentUser } from "../../Store/actions/apiActions";
import { Box } from "@mui/system";
import CustomDivider from "../../Components/Common/CustomDivider";
import { useAuth } from "react-oidc-context";

const SundayBreakfast = () => {
  const { currentInvitee } = useSelector((state) => state.apiReducer);
  const dispatch = useDispatch();

  const auth = useAuth();

  useEffect(() => {
    if (auth.isAuthenticated 
        && auth?.user?.id_token
        // && auth?.user?.profile["custom:userId"]
    ) {
      dispatch(getCurrentUser(auth.user));
    }
  }, [dispatch, auth]);

  const MyCustomDivider = () => {
    return <CustomDivider style={{ margin: `15px 40%`, width: `20%` }} />
  }

  return (
    <Grid container overflow="hidden">
      <Grid item xs={0} md={3} />
      <Grid item xs={12} md={6}>
        <Box>
          <br />
          <Typography variant="h3" sx={{ mt: 1 }}>
            Dear {currentInvitee?.name}
          </Typography>
          <MyCustomDivider />
          <Typography variant="h4">
            We’re excited to invite you to the after-wedding breakfast! 🍳
          </Typography>
          <Typography variant="h4">
          For those staying at the wedding venue, breakfast is included.
          </Typography>
          <Typography variant="h4">
          If you’re staying elsewhere, you’re still very welcome to join us for an additional cost of R195 (own account).
          </Typography>
          <Typography variant="h4">
          We look forward to enjoying a relaxing morning with you after the celebrations.
          </Typography>
          <MyCustomDivider />
          <Typography variant="h4">
          With warm regards,
          </Typography>
          <Typography variant="h4">
          Your Bride & Groom
          </Typography>
          <Typography variant="h3">
            Gabriella & Marco
          </Typography>
          <br/>
        </Box>
      </Grid>
      <Grid item xs={0} md={3} />
    </Grid>
  );
};

export default SundayBreakfast;
